import Board from './Board'
import Robot from './Robot'
import Log from './Log'
import Record from './Record'

function _clone(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = _clone(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = _clone(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

class Game {
  constructor(){
    this.board = []
    this.robots = {}
    this.robotColors = ['green', 'blue', 'red', 'yellow']
    this.goal = []
    this.goals = []
    this.goalColor = ""
    this.solution = []
    this.boardInstance
    this.logInstance
  }

  newBoard(data, isOldChallenge){
    var config, goals, robots, challengeId
    if(data){
      var { config, goals, robots, challengeId } = data
    }
    this.boardInstance = new Board(config);
    this.board = this.boardInstance.board;
    this.goals = goals || this.boardInstance.getGoals();
    if(config !== undefined && goals){
      this.isChallenge = true
      this.logInstance = new Log(true, challengeId, isOldChallenge);
      this.challengeId = challengeId
      this.challengeRobots = robots
      this.newChallengeRobots()
      this.generateChallengeLog()
      this.newChallengeGoal()
    } else {
      this.challengeId = null
      this.isChallenge = false
      this.logInstance = new Log()
      this.newGoal()
    }
    return this.board;
  }

  saveSolution(){
    if(this.solution.length && this.solution.length < this.logInstance.getCurrentRecordLength()){
      this.logInstance.modifyRecord({
        solution: this.solution.slice()
      })
      this.solution = []
    }
  }

  newGoal(){
    this.saveSolution()
    if(!this.goals.length){
      this.goals = this.boardInstance.getGoals()
    }
    var random = Math.floor(Math.random()*this.goals.length)
    this.goal = this.goals.splice(random, 1)[0]
    this.goalColor = this.robotColors[Math.floor(Math.random()*this.robotColors.length)]
    //pick a different color if the color robot is on the goal
    while(this.robots[this.goalColor] && this.isDestination()){
      this.goalColor = this.robotColors[Math.floor(Math.random()*this.robotColors.length)]
    }
    //save this to log
    this.logInstance.createNewRecord(this.getDataForLog())
    return this.goal
  }

  newChallengeGoal(){
    this.loadState(this.logInstance.getCurrentRecord())
    return this.goal
  }

  nextChallengeGoal(){
    this.saveSolution()
    this.loadState(this.logInstance.nextRecord())
  }

  newRobots(skipLog){
    var self = this;
    var disabledLists = [[7,8], [7,7], [8,7], [8,8]]
    this.robotColors.forEach((color)=>{
      var newRobot = new Robot(color, disabledLists)
      self.robots[color] = newRobot;
      disabledLists.push(newRobot.location)
    })
    for(var color in this.robots){
      this.robots[color].destinations = this.findDestinations(this.robots[color].location);
    }
    !skipLog && this.logInstance.modifyRecord({
      robotPositions: this.getRobots()
    })
    return this.getRobots();
  }

  newChallengeRobots(){
    var self = this;
    this.challengeRobots.forEach((info)=>{
      var color = info[2]
      var newRobot = new Robot(color, null, info)
      self.robots[color] = newRobot;
    })
    for(var color in this.robots){
      this.robots[color].destinations = this.findDestinations(this.robots[color].location);
    }
    return this.getRobots();
  }

  loadState(state, isNewRecord){
    //reset solution
    this.solution = []
    //reset robot
    this.robots = _clone(state.robotPositions)
    //load goals
    this.goal = state.goal
    this.goalColor = state.goalColor
    // //reset 
    // if(state.boardConfig !== this.boardInstance.config){
    //   this.board = this.boardInstance.generateBoard(state.boardConfig)
    // }
    //set current log
    this.logInstance.currentRecordIndex = state.recordIndex
    //create new record
    if(isNewRecord){
      this.logInstance.createNewRecord(this.getDataForLog())
    }
  }

  loadGoal(state){
    //reset solution
    this.solution = []
    //load goals
    this.goal = state.goal
    this.goalColor = state.goalColor
    //set current log
    this.logInstance.currentRecordIndex = state.recordIndex
  }

  getRobots(){
    return _clone(this.robots)
  }

  getLogs(){
    return {
      records: _clone(this.logInstance.store),
      currentRecordIndex: this.logInstance.currentRecordIndex,
      remainingPuzzle: this.logInstance.remainingPuzzle,
      totalMoves: this.logInstance.totalMoves,
      isChallenge: this.isChallenge
    }
  }

  getChallengeLog(){
    let log
    if(localStorage.getItem('currentChallenge') && localStorage.getItem('currentChallenge') !== 'undefined'){
      log = JSON.parse(localStorage.getItem('currentChallenge'))
    }
    if(log && this.challengeId === log.challengeId){
      this.logInstance.store = log.store.map(function(record, index){
        return new Record(record, index)
      })
      this.logInstance.currentRecordIndex = log.currentRecordIndex
      this.logInstance.challengeId = log.challengeId
      this.logInstance.remainingPuzzle = log.remainingPuzzle
      this.logInstance.totalMoves = log.totalMoves
      return true
    } 
    return false
  }

  generateChallengeLog(){
    //fetch local storage's challenge log if possible
    if(this.getChallengeLog()) return;
    //otherwise create new log and save it in local storage
    this.goals.forEach(function(goal){
      this.logInstance.createNewRecord(this.getDataForLog(goal.slice(), goal[2]))
    }.bind(this))
  }

  getDataForLog(goal, color){
    return {
      boardConfig: this.boardInstance.config,
      robotPositions: this.getRobots(),
      goal: goal || this.goal.slice(),
      goalColor: color || this.goalColor
    }
  }

  moveRobot(color, direction){
    const new_location = this.robots[color].destinations[direction]
    if (new_location.every((val, key) => (this.robots[color].location[key] === val)))
      return { moved: false }
    this.robots[color].location = new_location
    for(var robotColor in this.robots){
      this.robots[robotColor].destinations = this.findDestinations(this.robots[robotColor].location);
    }
    this.solution.push(color)
    this.solution.push(direction)
    return {
      targetReached: this.isDestination(),
      moved: true
    }
  }

  findDestinations(location){
    return {
      right: this.moveRight(location[0], location[1]),
      left: this.moveLeft(location[0], location[1]),
      up: this.moveUp(location[0], location[1]),
      down: this.moveDown(location[0], location[1]),
    }
  }

  isDestination(){
    let robot = this.robots[this.goalColor].location
    return robot[0] === this.goal[0] && robot[1] === this.goal[1]
  }

  isOccupied(row,col){
    for(var color in this.robots){
      var robot = this.robots[color].location;
      if(row === robot[0] && col === robot[1]){
        return true
      }
    }
    return false;
  }

  moveRight(row,col){
    var free = true,
        index = col;
    while(index < this.board.length && free){
      if(this.board[row][index].rightWall || this.board[row][index+1].leftWall || this.isOccupied(row, index+1)){
        free = false;
      } else {
        index++      
      }
    }
    return [row, index]
  }

  moveLeft(row,col){
    var free = true,
        index = col;
    while(index >= 0 && free){
      if(this.board[row][index].leftWall || this.board[row][index-1].rightWall || this.isOccupied(row, index-1)){
        free = false;
      } else {
        index--     
      }
    }
    return [row, index]
  }

  moveUp(row,col){
    var free = true,
        index = row;
    while(index >= 0 && free){
      if(this.board[index][col].upWall || this.board[index-1][col].downWall || this.isOccupied(index-1, col)){
        free = false;
      } else {
        index--     
      }
    }
    return [index, col]
  }


  moveDown(row,col){
    var free = true,
        index = row;
    while(index < this.board.length && free){
      if(this.board[index][col].downWall || this.board[index+1][col].upWall || this.isOccupied(index+1, col)){
        free = false;
      } else {
        index++     
      }
    }
    return [index, col]
  }
}

const game = new Game()

export default game



// WEBPACK FOOTER //
// ./game/Game.js